import React from 'react';
import { Helmet } from 'react-helmet';
import './BookLandingPage.css';

const SITE_URL = 'https://jerryevanoff.com';

const STORE_PILLS = [
  { key: 'ebookAmazonUrl', label: 'eBook / Kindle Unlimited' },
  { key: 'paperbackAmazonUrl', label: 'Paperback at Amazon' },
  { key: 'paperbackBOUrl', label: 'Paperback at B&N' },
  { key: 'etsySignedPaperbackUrl', label: 'Signed Paperback at Etsy', featured: true }
];

const BookLandingPage = ({
  pageUrl,
  pageTitle,
  pageDescription,
  metaKeywords,
  coverImage,
  title,
  subtitle,
  genreLine,
  bodyParagraphs,
  perfectForText,
  buyLinks,
  readingOrder,
  schema
}) => {
  const ogTitle = `${title} by Jerry Evanoff`;
  const localCoverSrc = coverImage.replace(SITE_URL, '');

  return (
    <section className="book-landing-page">
      <Helmet>
        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={metaKeywords} />
        <meta name="author" content="Jerry Evanoff" />

        <link rel="canonical" href={pageUrl} />

        <meta property="og:type" content="book" />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={coverImage} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="Jerry Evanoff" />
        <meta property="book:author" content="Jerry Evanoff" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={coverImage} />

        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <div className="book-landing-container">
        <div className="book-landing-main">
          <h1 className="book-landing-title">{title}</h1>
          <h2 className="book-landing-subtitle">{subtitle}</h2>

          <div className="book-landing-hero">
            <div className="book-landing-cover-block">
              <a href={buyLinks.ebookAmazonUrl} target="_blank" rel="noopener noreferrer">
                <img
                  src={localCoverSrc}
                  alt={ogTitle}
                  className="book-landing-cover"
                />
              </a>

              <div className="cover-click-note">(click to purchase)</div>
            </div>

            <div className="book-landing-copy">
              <p className="genre-line">{genreLine}</p>

              {bodyParagraphs.map((paragraph, index) => (
                paragraph.bold ? (
                  <p key={index}><strong>{paragraph.text}</strong></p>
                ) : (
                  <p key={index}>{paragraph.text}</p>
                )
              ))}

              <div className="buy-button-wrapper">
                <a href={buyLinks.ebookAmazonUrl} target="_blank" rel="noopener noreferrer" className="book-landing-buy-button">
                  Read Sample or Purchase at Amazon
                </a>
              </div>
            </div>
          </div>

          <div className="reader-fit">
            <h3>Perfect for readers who enjoy:</h3>
            <p>{perfectForText}</p>
          </div>
        </div>

        <aside className="book-landing-reading-order">
          <div className="book-landing-store-card">
            <h3 className="book-landing-sidebar-heading">Get the Book</h3>

            <div className="book-landing-store-links-compact">
              {STORE_PILLS.map(({ key, label, featured }) => (
                <a
                  key={key}
                  href={buyLinks[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`book-landing-store-pill${featured ? ' book-landing-store-pill-featured' : ''}`}
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          <div className="book-landing-reading-card">
            <h3 className="book-landing-reading-label">Suggested Reading Order</h3>

            <ol className="book-landing-reading-compact-list">
              {readingOrder.map((book) => (
                <li key={book.title} className={book.current ? 'book-landing-reading-current' : ''}>
                  <span>{book.title}</span>
                  <small>{book.subtitle}</small>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default BookLandingPage;
